<div class="wizard-step-container">
  <div class="start-step-container">
    <div class="start-step-contents">
      <div class="wizard-step-header">
        <h1 class="wizard-step-title" role="heading" aria-level="1" [attr.aria-label]="title">{{title}}</h1>
        <p class="wizard-step-subtitle" role="heading" aria-level="2" [attr.aria-label]="subtitle">{{subtitle}}</p>
      </div>
      <div class="">
        <app-wizard-navigation
          [currentStepName]="analyticsStepName"
          [isStartStep]="true"
          [nextStepRoute]="'/primary-use'"
          [hideBackButton]="true"></app-wizard-navigation>
      </div>
    </div>
  </div>
</div>
<app-progress-bar></app-progress-bar>

